export class ExamType {
  _id: string;
  exam: string;
  material: string;
  department: string;
  vet: string;
}
